module.exports = __webpack_public_path__ + "img/img_market_produce@3x.12059f24.png";